import React, { useState, useEffect } from 'react';
import { getTickets, replyTicket } from '../services/api';
import './AdminSupport.css';

const STATUS_BADGES = { open: 'badge-warning', in_progress: 'badge-info', resolved: 'badge-success', closed: 'badge-gray' };

export default function AdminSupport() {
  const [tickets, setTickets] = useState([]);
  const [selected, setSelected] = useState(null);
  const [reply, setReply] = useState('');
  const [replyStatus, setReplyStatus] = useState('in_progress');
  const [sending, setSending] = useState(false);
  const [filter, setFilter] = useState('');

  const load = () => {
    getTickets({ status: filter })
      .then(r => setTickets(r.data))
      .catch(console.error);
  };

  useEffect(load, [filter]);

  const handleReply = async () => {
    if (!reply.trim() || !selected) return;
    setSending(true);
    try {
      await replyTicket(selected.id, { reply, status: replyStatus });
      setReply('');
      load();
      setSelected(prev => ({ ...prev, admin_reply: reply, status: replyStatus }));
    } catch (err) {
      alert('Reply failed: ' + (err.response?.data?.error || err.message));
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="container" style={{ padding: '2rem 1.5rem' }}>
      <div className="page-header"><h1>Support Tickets</h1><p>Respond to customer inquiries.</p></div>

      <div style={{ marginBottom: '1rem' }}>
        <select className="form-control" value={filter} onChange={e => setFilter(e.target.value)} style={{ width: 'auto' }}>
          <option value="">All Tickets</option>
          <option value="open">Open</option>
          <option value="in_progress">In Progress</option>
          <option value="resolved">Resolved</option>
          <option value="closed">Closed</option>
        </select>
      </div>

      <div className="support-layout">
        {/* Ticket List */}
        <div className="ticket-list">
          {tickets.length === 0 ? (
            <div className="card" style={{ textAlign: 'center', padding: '2rem', color: 'var(--gray-400)' }}>No tickets.</div>
          ) : tickets.map(t => (
            <div
              key={t.id}
              className={`ticket-row card ${selected?.id === t.id ? 'selected' : ''}`}
              onClick={() => setSelected(t)}
            >
              <div className="ticket-row-top">
                <span className="ticket-from">{t.name}</span>
                <span className={`badge ${STATUS_BADGES[t.status] || 'badge-gray'}`}>{t.status}</span>
              </div>
              <div className="ticket-subject">{t.subject}</div>
              <div className="ticket-meta">
                <span>{t.email}</span>
                {t.order_number && <span>Order: {t.order_number}</span>}
                <span>{new Date(t.created_at).toLocaleDateString()}</span>
              </div>
            </div>
          ))}
        </div>

        {/* Detail */}
        {selected ? (
          <div className="ticket-detail-panel card">
            <div className="ticket-panel-header">
              <div>
                <p style={{ fontSize: '0.75rem', color: 'var(--gray-500)', fontFamily: 'monospace' }}>{selected.ticket_number}</p>
                <h2 style={{ fontSize: '1rem', fontWeight: 600 }}>{selected.subject}</h2>
              </div>
              <span className={`badge ${STATUS_BADGES[selected.status] || 'badge-gray'}`}>{selected.status}</span>
            </div>

            <div className="ticket-panel-info">
              <p><strong>From:</strong> {selected.name} &lt;{selected.email}&gt;</p>
              {selected.order_number && <p><strong>Order:</strong> {selected.order_number}</p>}
            </div>

            <div className="ticket-message-box">
              <p className="message-label">Customer Message:</p>
              <p>{selected.message}</p>
            </div>

            {selected.admin_reply && (
              <div className="admin-reply-box">
                <p className="message-label">Your Previous Reply:</p>
                <p>{selected.admin_reply}</p>
              </div>
            )}

            <div style={{ marginTop: '1rem' }}>
              <label className="form-label">Reply to Customer</label>
              <textarea
                className="form-control"
                rows={5}
                placeholder="Type your response..."
                value={reply}
                onChange={e => setReply(e.target.value)}
              />
              <div style={{ display: 'flex', gap: '0.75rem', marginTop: '0.75rem', alignItems: 'center' }}>
                <select className="form-control" style={{ width: 'auto' }} value={replyStatus} onChange={e => setReplyStatus(e.target.value)}>
                  <option value="in_progress">Mark: In Progress</option>
                  <option value="resolved">Mark: Resolved</option>
                  <option value="closed">Mark: Closed</option>
                </select>
                <button className="btn btn-primary" onClick={handleReply} disabled={sending || !reply.trim()}>
                  {sending ? 'Sending...' : '📤 Send Reply'}
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div className="card" style={{ textAlign: 'center', padding: '3rem', color: 'var(--gray-400)' }}>
            Select a ticket to reply.
          </div>
        )}
      </div>
    </div>
  );
}
